import { atom, PrimitiveAtom, SetStateAction, WritableAtom } from 'jotai';
import { RESET } from 'jotai/utils';
import { isEqual } from 'lodash';

type FiltersAtomProps<TFilters> = {
  initialFiltersAtom: WritableAtom<TFilters, [typeof RESET | SetStateAction<TFilters>], void>;
  pageAtom: PrimitiveAtom<number>;
  initialFilters: TFilters;
};

export const paginatedFiltersAtom = <TFilters>({
  initialFiltersAtom,
  initialFilters,
  pageAtom,
}: FiltersAtomProps<TFilters>) =>
  atom(
    (get) => get(initialFiltersAtom),
    (get, set, newValue: SetStateAction<TFilters> | typeof RESET) => {
      const currentRSimFilters = get(initialFiltersAtom);
      if (!isEqual(currentRSimFilters, newValue)) {
        set(pageAtom, 0);
      }

      if (newValue === RESET) {
        return set(initialFiltersAtom, initialFilters);
      }

      return set(initialFiltersAtom, newValue);
    },
  );
